import { SettingsPage } from "./configuration.js";
import { TeamSettingsPage } from "./teams.js";

export const settingsRoutes = [
  { path: "settings", element: <SettingsPage /> },
  { path: "organization", element: <TeamSettingsPage /> },
  { path: "teams", element: <TeamSettingsPage /> },
  { path: "settings/teams", element: <TeamSettingsPage /> },
];
